const historyGeneral = {
	data() {
		return {
			generalTable: []
		}
	},
	created() {
		this.generalSituation()
	},
	methods: {
		generalSituation() {
			const params = {
				examIds: this.query.examIds,
				schoolId: this.query.schoolId
			}
			this.$post('reportApi/queryExamGeneralSituation', params).then(res => {
				this.generalTable = res.data
			})
		}
	}
}
export default historyGeneral
